import { IonButton , IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonSpinner } from "@ionic/react";
import Box from "@mui/material/Box";
import { DataGrid , deDE } from "@mui/x-data-grid";
import { useContext , useState } from "react";
import { useHistory } from 'react-router-dom';
import { defColumn , defColumnRenderCell , einweisungstypKeyToTitle , exportTableData } from './_HelperFunctions' ;
import { useEinweisungenListe , useEinweisungsThemen, useMitarbeiterListe } from '../components/_CustomHooks';
import { AppContext } from "../contexts/app_context";
import './table_einweisungen_grid.css'

function EinweisungenListe() {
  /** Component Environment */
    const { appEinweisungenIdChange , appEinweisungenListeData , appEinweisungenListeFetchState , appEinweisungsThemenListe , appMitarbeiterListe , appViewSwitchChange } = useContext( AppContext ) ;
    const history = useHistory();
    const [pageSize, setPageSize] = useState(50);
  /** Component Helpers */
    const setTitle = ( tablePurpose ) => {
      if( tablePurpose === 'offen' ) { return 'Offen' ; }
      if( tablePurpose === 'abgeschlossen' ) { return 'Abgeschlossen' ; }
    }
    const setFieldForRowId = ( tablePurpose ) => {
      if( tablePurpose === 'offen' ) { return 'EinweisungenId' ; }
      if( tablePurpose === 'abgeschlossen' ) { return 'EinweisungenId' ; }
    }
    const dataForPurpose = ( tablePurpose ) => {
      if( tablePurpose === 'offen' ) {
        return appEinweisungenListeData
          .filter(
            ( entry ) => entry.EinweisungenStatus === 'offen'
           )
           .filter(
            ( entry ) =>
              {
                if(
                  appEinweisungsThemenListe
                    .findIndex(
                      ( thema ) => {
                        if( thema.SchulungenId === entry.EinweisungenThema ) {
                          if( thema.SchulungenAktiv === 'aktiv' ) {
                            return true
                          }
                          return false ;
                        }
                        return false ;
                      }
                    ) > -1
                )
                  { 
                    return true ;
                  }
                return false ;
              }
           )
      }
      if( tablePurpose === 'abgeschlossen' ) {
        return appEinweisungenListeData
          .filter(
            ( entry ) => entry.EinweisungenStatus === 'abgeschlossen'
           );
      }
    }
    const setSorting = ( tablePurpose ) => {
      if( tablePurpose === 'offen' ) {
        return { field: 'EinweisungenTermin' , sort: 'asc' }
      }
      if( tablePurpose === 'abgeschlossen' ) {
        return { field: 'EinweisungenTermin' , sort: 'desc' }
      }
    }
    const mkTable = ( tablePurpose ) =>  {
      return (
        <IonCard>
          <IonCardHeader>
            <IonCardTitle>
              { setTitle( tablePurpose ) }
            </IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            <Box
                sx={{
                  height: 300 ,
                  width: 1,
                  "& .super-app-theme--header": {
                    backgroundColor: "rgb(211,211,211)",
                  },
                }}
              >
                {
                  appEinweisungenListeFetchState === 100 ? (
                    <IonSpinner name="bubbles" />
                  ) : (
                    <DataGrid
                      headerHeight = { 56 }
                      // "loading" muss offenbar anderweitig wieder auf "false" gesetzt werden
                      // loading = { true }
                      disableVirtualization 
                      componentsProps = {{
                        toolbar: {
                          tablePurpose: tablePurpose
                        }
                      }}
                      initialState={{
                        sorting: {
                          sortModel: [ setSorting( tablePurpose ) ] ,
                        },
                      }}
                      getRowId = { (row) => row[ setFieldForRowId( tablePurpose ) ] }
                      rows={ dataForPurpose( tablePurpose) }
                      columns =
                        {
                          [
                            {
                              field: 'EinweisungenId' ,
                              hide: true
                            } ,
                            //#region EinweisungenMitarbeiterTermin
                              /** "EinweisungenMitarbeiterId"
                               *    - ! genau so in verschiedenen Komponenten an verschiedenen Stellen
                               *        => wg. lokaler Daten-States statt useContext vorerst via
                               *           Copy & Paste zu handlen
                               */
                                defColumnRenderCell(
                                  defColumn( "EinweisungenTermin" , "Termin" , 100 , 0 ) ,
                                  ( data ) => data.row.EinweisungenTermin === '0000-00-00'
                                      ?
                                        '(offen)'
                                      : 
                                        new Date( data.row.EinweisungenTermin ).toLocaleDateString()
                                ) ,
                              //#endregion EinweisungenMitarbeiterTermin
                              defColumn( 'EinweisungenDozent' , 'Dozent/in' , 140 , 0 ) ,
                              defColumnRenderCell(
                              defColumn( "EinweisungenTyp" , "Typ" , 120 , 0 ) ,
                              ( data ) => einweisungstypKeyToTitle( data.row.EinweisungenTyp )
                            ) ,
                            defColumnRenderCell(
                              defColumn( 'EinweisungenThema' , 'Thema' , 300 , 1 , 300 ) ,
                              ( params ) => {
                                if( params.row.EinweisungenThema ) {
                                  let matchesEinweisungenTitel = appEinweisungsThemenListe
                                  .find(
                                      ( entry ) => entry.SchulungenId === params.row.EinweisungenThema
                                    )
                                  if( matchesEinweisungenTitel ) {
                                    return matchesEinweisungenTitel.SchulungenTitel ;
                                  }
                                }
                              }
                            ) ,
                            //#region EinweisungenMitarbeiterId
                              /** "EinweisungenMitarbeiterId"
                               *    - ! genau so in verschiedenen Komponenten an verschiedenen Stellen
                               *        => wg. lokaler Daten-States statt useContext vorerst via
                               *           Copy & Paste zu handlen
                               */
                                defColumnRenderCell(
                                  defColumn( "EinweisungenMitarbeiterId" , "Teilnehmer" ) ,
                                  ( params ) => {
                                    if( params.row.EinweisungenMitarbeiterId ) {
                                      let matchesMitarbeiterDB = appMitarbeiterListe
                                        .filter(
                                          ( { MitarbeiterId } ) =>
                                          /** Präfigierung mit ',' für z.B. "89" vs. "189" (",89" vs. ",189")
                                           *  - in Klammern wg. "( ',' xy).includes" vs. "',' + (xy.includes)"  
                                           */
                                            ( ',' + params.row.EinweisungenMitarbeiterId + ',' )
                                              .includes( ',' + MitarbeiterId + ',' )
                                          )
                                        .map(
                                          ( { MitarbeiterNachname } ) => MitarbeiterNachname
                                        )
                                      if( matchesMitarbeiterDB ) {
                                        return matchesMitarbeiterDB.toString() ;
                                      }
                                    }
                                  }
                                )
                              //#endregion EinweisungenMitarbeiterId
                          ]
                        } 
                      rowsPerPageOptions={[50,100]}
                      disableSelectionOnClick
                      onCellClick = {
                        ( e ) => { 
                          appViewSwitchChange( true ) ;
                          appEinweisungenIdChange ( e.id ) ;
                          history.push( '/einweisung/' + e.id ) ;
                          return ;
                          }
                        }
                      pageSize={pageSize}
                      onPageSizeChange={(newPage) => setPageSize(newPage)}
                      pagination
                      localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                    />
                  )
                }
            </Box>
            {
              appEinweisungenListeData.length > 0
                ?
                  <IonButton onClick={ () => exportTableData( dataForPurpose( tablePurpose) , 'Einweisungen ' + tablePurpose ) }>Exportieren</IonButton>
                :
                  ''
            }
            <IonButton onClick={ () => { appEinweisungenIdChange( 'neu' ) ; history.push( "/einweisung/neu/" ) ; } }>Neue Einweisung</IonButton>
          </IonCardContent>
        </IonCard>
      )
    }
  /** Component Mount-Update */
    useEinweisungenListe() ;
    useEinweisungsThemen() ;
    useMitarbeiterListe() ;

/** Component UI */
    return (
      <>
        {/* { mkTable( 'matrix' ) } */}
        {/* <EinweisungenMatrix/> */}
        { mkTable( 'offen' ) }
        { mkTable( 'abgeschlossen' ) }
      </>
    );
}
export default EinweisungenListe;
